import React from "react";
import PropTypes from "prop-types";
import { TemplateObject } from "~/pages/ProjectTemplates/TemplateObject";
import { TemplateTaskPanelContainer } from "./Panel/TemplateTaskPanelContainer";
import { TemplateTaskBody } from "./TemplateTaskBody";

export const TemplateTask = ({ taskId, templateId }) => {
  return (
    <TemplateObject>
      <TemplateTaskBody taskId={taskId} />
      <TemplateTaskPanelContainer
        taskId={taskId}
        templateId={templateId}
      />
    </TemplateObject>
  );
};

TemplateTask.propTypes = {
  taskId: PropTypes.number.isRequired,
  templateId: PropTypes.number.isRequired,
};
